export default __webpack_public_path__ + "static/media/6.Breeching-inlet.ff26605b.jpg";